import { BASIC_NODE_CONFIG, BASIC_NODE_CONFIG_SIZE } from 'src/utils/basic'
import type { LLMActionNodeType } from '../types'

export function generateLLMNodeConfig(id: string): LLMActionNodeType {
  return {
    ...BASIC_NODE_CONFIG,
    id,
    type: 'LLMAction',
    data: {
      ...BASIC_NODE_CONFIG_SIZE,
      nodeName: '提示词',
      nodeType: 'LLMAction',
      nodeData: {},
      nodeStyle: {},
      nodeId: '',
      hasErr: false,
      errInfo: [],
    },
    position: {
      x: 0,
      y: 0,
    },
  }
}
